import styled from 'styled-components';

export default styled.sup `

`;
